// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2_Jbk","content":"LoadingAlert_content__1ZDPf"};